module.exports = __webpack_public_path__ + "img/user-visor.3963824d.svg";